import { DictionaryPhrases } from '@sitecore-jss/sitecore-jss-nextjs';
import React from 'react';

export const DictionaryContext = React.createContext<DictionaryPhrases>(
  {} as unknown as DictionaryPhrases
);

const useDictionary = () => React.useContext(DictionaryContext);

export default useDictionary;
